import React from 'react';
import AlphabetBar from '../AlphabetBar';
import GridList from './GridList';
import GridViewStyles from './styles';

const GridView = ({ data, isFetching, total, fetchNextPage }) => (
  <GridViewStyles className="grid-view">
    <AlphabetBar />
    <GridList
      data={data}
      isFetching={isFetching}
      total={total}
      fetchNextPage={fetchNextPage}
    />
  </GridViewStyles>
);

export default GridView;
